import { render } from "./GRBG_nnp.vue?vue&type=template&id=4bd1ab91&scoped=true"
import script from "./GRBG_nnp.vue?vue&type=script&lang=js"
export * from "./GRBG_nnp.vue?vue&type=script&lang=js"

import "./GRBG_nnp.vue?vue&type=style&index=0&id=4bd1ab91&scoped=scoped&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd1ab91"]])

export default __exports__